import React, { useState } from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import UserGiftlistRow from '../Dashboard/UserGiftlistRow';
import SuggestedRow from './SuggestedRow';
import UserSearch from './UserSearch';
import EmptyState from '../General/EmptyState';

const NiceList = (props) => {

    const [tabview, setTabview] = useState("nicelist");

    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [giftlists] = useGlobal(
        state => state.giftlists
    );

    const [suggesteds] = useGlobal(
        state => state.suggesteds
    );

    const [user] = useGlobal(
        state => state.user
    );

    const [mygiftlistCount] = useGlobal(
        state => state.mygiftlist.length
    );

    const closePanel = () => {
        uiActions.closeSidePanel();
    }
    const myrow = <UserGiftlistRow me={true} totalItems={mygiftlistCount} giftlist={user} close={closePanel}></UserGiftlistRow>
    const nicelist = giftlists.map(gl => <UserGiftlistRow key={gl.userID} giftlist={gl} close={closePanel}></UserGiftlistRow>);
    const suggestedList = suggesteds.map(gl => <SuggestedRow key={gl.userID} giftlist={gl}></SuggestedRow>);

    return (
        <Panel open={props.open && panel.name === "nicelist"}>
            {props.name === "nicelist" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white" kt-hidden-height="77">
                    <ul className="nav nav-pills" role="tablist">
                        <li className="nav-item active">
                            <a className={`nav-link ${tabview === "nicelist" ? "active" : ""}`} data-toggle="tab" href="#!" onClick={() => setTabview('nicelist')} role="tab">Gift Lists ({giftlists.length})</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${tabview === "suggested" ? "active" : ""}`} data-toggle="tab" href="#!" onClick={() => setTabview('suggested')} role="tab">Suggested <span className="kt-hidden-mobile">Lists </span>({suggesteds.length})</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${tabview === "search" ? "active" : ""}`} data-toggle="tab" href="#!" onClick={() => setTabview('search')} role="tab">Search</a>
                        </li>
                    </ul>
                    <button className="kt-offcanvas-panel__close" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                <div className="kt-offcanvas-panel__body">
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" id="kt_quick_panel_tab_notifications" role="tabpanel" >
                            {tabview === "suggested" ? suggesteds.length > 0 ? <p>We found some gift lists you may want to add.</p> : <EmptyState message="We couldn't find any lists related to your current connections."></EmptyState> : <></> }
                            {tabview === "search" ? <p>Search for a particular user by their full email address.</p> : <></> }
                            {tabview === "nicelist" ? myrow : <></>}
                            {tabview === "nicelist" ? nicelist : tabview === "suggested" ? suggestedList : <UserSearch></UserSearch>}
                        </div>
                    </div>
                </div>
                </> : <></>}
        </Panel>

    );
}

export default NiceList;